import React from "react"
import {
  UncontrolledDropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap"

export const ActionsDropdown = ({
  children,
  label,
  icon = "mdi mdi-chevron-down",
  actionsList,
  menuPosition,
  size = "",
  fullWidth,
  color = "primary",
}) => {
  const clickHandler = action => event => {
    event.preventDefault()
    action.onClick()
  }
  return (
    <UncontrolledDropdown size={fullWidth ? "12" : size}>
      <DropdownToggle
        // tag="button"
        className="btn btn-primary full-width"
        caret
        color={color}
      >
        {label} &nbsp;
        {/* <i className={icon} /> */}
      </DropdownToggle>
      <DropdownMenu className={`dropdown-menu-${menuPosition}`}>
        {actionsList.map((a, index) => (
          <DropdownItem
            key={index}
            href="#"
            onClick={clickHandler(a)}
            disabled={!a.isAvailable}
            className={"d-flex align-items-center"}
          >
            <i className={`${a.icon} bx-xs me-1`} /> {a.name}
          </DropdownItem>
        ))}
      </DropdownMenu>
    </UncontrolledDropdown>
  )
}
